import {GlobalVariables} from "../GlobalVariables";
import {ScrollTrigger} from "../LibrariesImport";

export default class AsideForm {
	constructor() {

		this.asideForm = document.querySelector('.aside-form');
		if (!this.asideForm) {
			return;
		}

		let openButtons = document.querySelectorAll(".open-aside-form");
		openButtons.forEach((openButton) => {

			openButton.addEventListener("click", (e) => {
				e.preventDefault();
				this.revealForm();
			});
		});

		if (document.querySelector(".footer-main")) {
			ScrollTrigger.create({
				trigger: ".footer-main",
				start: 'top bottom',
				end: 'bottom center',
				toggleClass: {targets: ".open-aside-form", className: "hide"}
			});
		}

		let buttonClose = document.querySelector(".aside-form-close");
		if (buttonClose) {
			buttonClose.addEventListener("click", (e) => {
				e.preventDefault();
				this.close();
			});
		}

		this.asideForm.addEventListener('click', e => {
			if (e.target !== this.asideForm) {
				return;
			}
			this.close();
		});


		document.addEventListener("escape.pressed", () => {
			this.close();
		});
	}

	close() {
		document.body.classList.remove("aside-form-open");
		GlobalVariables.lenis?.start();
	}

	revealForm() {
		this.asideForm.classList.remove('d-none');

		setTimeout(() => {
			document.body.classList.toggle("aside-form-open", !document.body.classList.contains('aside-form-open'));
			GlobalVariables.lenis?.stop();
		}, 0);
	}
}
